export default __webpack_public_path__ + "static/media/wellness_check_icon.543ba43a.png";